<template>
  <div class="article">
    <div class="article-container-create">
      <div class="article-content">
        <img :src="file ? base64Img : placeholder" alt="" />
      </div>
      <div class="article-content">
        <div class="main-button" :class="{ disable: false }" @click.stop="openInput">
          {{ $t('upload.chooseFileImage') }}
        </div>
      </div>

      <ArticleEditor v-model="titleContent" :title="$t('title')" height="90px" :maxlength="200" />

      <ArticleEditor v-model="resumeContent" :title="$t('summary')" height="160px" :maxlength="1000" />

      <ArticleEditor v-model="mainContent" :title="$t('content')" height="500px" :maxlength="8000" />

      <VideoEditor v-model="iframeHTML" />

      <div class="article-content">
        <div class="publish" @click="publish = !publish">
          <div class="checkbox" :class="{ checked: publish }"></div>
          <div class="checkbox-label">{{ $t('publish') }}</div>
        </div>
      </div>
      <div class="article-content">
        <div class="main-button cancel" :class="{ disable: false }" @click.stop="$router.go(-1)">
          {{ $t('cancel') }}
        </div>
        <div class="main-button" :class="{ disable: !isValid() }" @click.stop="add">
          {{ $t('create') }}
        </div>
      </div>
      <input :ref="'inputFile'" type="file" accept=".png, .jpeg, .jpg" class="input-file" hidden @change="uploadFile({}, $event)" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import placeholder from '@/assets/placeholder-upload.jpg';
import ArticleEditor from '@/components/ArticleEditor.vue';
import VideoEditor from '@/components/VideoEditor.vue';

export default {
  components: { ArticleEditor, VideoEditor },

  beforeRouteLeave(to, from, next) {
    if (this.isSend) return next();
    if ((this.titleContent || this.resumeContent || this.mainContent) && confirm(this.$t('areYouSureToExit'))) {
      return next();
    } else if (!(this.titleContent || this.resumeContent || this.mainContent)) {
      return next();
    }
  },

  data() {
    return {
      base64Img: null,
      file: null,
      publish: true,
      placeholder,
      isSend: false,
      titleContent: '',
      resumeContent: '',
      mainContent: '',
      iframeHTML: '',
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    encodeImage(input) {
      if (input) {
        const reader = new FileReader();
        reader.onload = e => {
          this.base64Img = e.target.result;
        };
        reader.readAsDataURL(input);
      }
    },

    async add() {
      this.isSend = true;
      const data = new FormData();
      this.mainContent += this.iframeHTML;
      data.append('title', this.titleContent);
      data.append('resume', this.resumeContent);
      data.append('content', this.mainContent);
      data.append('Image', this.file);
      data.append('IsPublished', this.publish);
      const result = await this.$store.dispatch('addArticle', {
        data,
      });
      this.$router.go(-1);
      return result;
    },

    async uploadFile(element, event) {
      if (!event.target.files[0]) {
        return;
      }
      this.file = event.target.files[0];
      this.encodeImage(this.file);
    },

    openInput() {
      this.$refs[`inputFile`].click();
    },

    isValid() {
      return this.titleContent.length && this.resumeContent.length && this.mainContent.length;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
@use '@/styles/variables.scss';
.line {
  display: flex;
  justify-content: space-between;

  .filters {
    align-self: flex-end;
    flex-grow: 1;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    height: 0;
    overflow: hidden;
    transition: all 0.3s;
    opacity: 0;

    &.enabled {
      height: 30px;
      opacity: 1;
    }

    .filter-btn {
      width: 36px;
      box-sizing: border-box;
      border: 1px solid colors.$lightgrey-color;
      margin-bottom: 6px;
      padding: 4px;
      border-radius: 4px;
      cursor: pointer;

      &.bold {
        font-weight: bold;
      }

      &.italic {
        font-style: italic;
      }

      &.underline {
        text-decoration: underline;
      }

      &:hover {
        background: colors.$lightgrey-color;
        border-color: colors.$grey-color;
      }

      &:not(:first-child) {
        border-left: 0;
      }

      &:nth-child(2n) {
        border-radius: 0;
      }

      &:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
}

.article {
  transition: all 0.2s;
  box-sizing: border-box;
  padding: 42px 180px;

  .title {
    color: colors.$darkblue-color;
    font-weight: 500;
    font-size: 20px;
    margin: 0 0 24px;

    &:not(:first-child) {
      padding-top: 24px;
    }
  }

  .article-content-create {
    flex-grow: 1;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border: 1px solid colors.$lightgrey-color;
    border-radius: 5px;
    padding: 30px;
    transition: all 0.3s;
    overflow-y: auto;

    &.article-title {
      min-height: 90px;
      max-height: 90px;
    }

    &.summary {
      max-height: 160px;
      min-height: 160px;
    }

    &.article-ct {
      max-height: 500px;
      min-height: 500px;
    }

    &:focus {
      border-radius: 5px !important;
      border: 1px solid colors.$lightblue-color;
      outline: none;
    }

    &.placeholder {
      color: colors.$grey-color;
    }
  }
  .article-content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;

    .publish {
      display: flex;

      &:hover {
        cursor: pointer;
      }

      .checkbox-label {
        margin-left: 8px;
      }
    }

    img {
      width: 400px;
      max-height: 400px;
      box-shadow: variables.$box-shadow;
      border-radius: 3px;
    }

    .info {
      height: 100%;
      color: colors.$red-color;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
    }

    .main-button {
      margin-top: 24px;
      max-width: 160px;
      cursor: pointer;

      &.disable {
        cursor: not-allowed;
        background: colors.$lightgrey-color;
      }

      &.cancel {
        background: colors.$lightgrey-color;
      }
    }
  }
}
</style>
